import { getUserNotificationsPreferenceForCurrentBrowser } from './getUserNotificationsPreferenceForCurrentBrowser';

/**
 * Utility function to get the push notifications onboarding campaign disabled state of a user
 */
export const getPushNotificationsOnboardingDisabled = async (): Promise<boolean> => {
    const currentClientNotificationPreference = await getUserNotificationsPreferenceForCurrentBrowser();
    return currentClientNotificationPreference?.onboardingDisabled ?? false;
};

/**
 * Utility function to get the total present browser impression count of push notifications onboarding campaign
 */
export const getPushNotificationsOnboardingImpressionCount = async (): Promise<number> => {
    const currentClientNotificationPreference = await getUserNotificationsPreferenceForCurrentBrowser();
    return currentClientNotificationPreference?.onboardingImpressionCount ?? 0;
};
